var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNewspaper = function SvgNewspaper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M2 44V25C2 24.4477 2.44772 24 3 24H10V44C10 46.2091 8.20914 48 6 48C3.79086 48 2 46.2091 2 44Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47.0001 2H45.5573V39C45.5527 42.8641 42.4214 45.9954 38.5573 46H11.6337C11.369 46.737 10.9647 47.4161 10.4429 48H41.0001C44.8642 47.9954 47.9955 44.8641 48.0001 41V3C48.0001 2.44772 47.5524 2 47.0001 2Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24H19C18.4477 24 18 24.4477 18 25C18 25.5523 18.4477 26 19 26H41C41.5523 26 42 25.5523 42 25C42 24.4477 41.5523 24 41 24Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32H19C18.4477 32 18 32.4477 18 33C18 33.5523 18.4477 34 19 34H41C41.5523 34 42 33.5523 42 33C42 32.4477 41.5523 32 41 32Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40H19C18.4477 40 18 40.4477 18 41C18 41.5523 18.4477 42 19 42H35C35.5523 42 36 41.5523 36 41C36 40.4477 35.5523 40 35 40Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8H40C41.1046 8 42 8.89543 42 10V16C42 17.1046 41.1046 18 40 18H20C18.8954 18 18 17.1046 18 16V10C18 8.89543 18.8954 8 20 8ZM20 16H40V10H20V16Z",
    fill: "#FC628F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 0H13C11.3439 0.00176371 10.0018 1.34388 10 3V22H3C1.34388 22.0018 0.00176371 23.3439 0 25V44C0 47.3137 2.68629 50 6 50H41C45.9683 49.9946 49.9946 45.9683 50 41V3C49.9982 1.34388 48.6561 0.00176371 47 0ZM2 44V25C2 24.4477 2.44772 24 3 24H10V44C10 46.2091 8.20914 48 6 48C3.79086 48 2 46.2091 2 44ZM41 48C44.8641 47.9954 47.9954 44.8641 48 41V3C48 2.44771 47.5523 2 47 2H13C12.4477 2 12 2.44771 12 3V44C11.9962 45.4805 11.441 46.9066 10.4428 48H41Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNewspaper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/newspaper.728b70e1ce037a1a9a264cbf296b48d1.svg";